// import { useState } from "react";
import { Text } from "react-native-paper";
// import { Feather } from "@expo/vector-icons";
import { View } from "react-native";
import { Employment } from "./EditScreen";
// import { colors } from "../../../theme";

const EmploymentSection = ({ employment, memberClass }: { employment: Employment; memberClass?: string }) => {
  // const [menuVisible, setMenuVisible] = useState(false);

  // const closeMenu = () => setMenuVisible(false);

  return (
    <View className="mt-4 rounded-lg border border-sky bg-sky-white flex p-6">
      <View className="flex-row justify-between items-center">
        <View>
          <Text className="text-small-tight font-400 text-ink-dark">Facility</Text>
          <Text className="text-regular-tight font-700 text-ink-darkest mt-1">{employment.facility.name}</Text>
        </View>
        {/* commenting out until implemented */}
        {/* <Menu
          contentStyle={{ backgroundColor: "#FFF", borderRadius: 8 }}
          visible={menuVisible}
          onDismiss={closeMenu}
          anchor={
            <TouchableOpacity testID="employment-menu-anchor" onPress={() => setMenuVisible(!menuVisible)} activeOpacity={0.6}>
              <View className="items-center justify-center">
                <Feather name="more-horizontal" size={24} color={colors.ink.darkest} />
              </View>
            </TouchableOpacity>
          }
        >
          <View testID="employment-menu-content">
            <TouchableOpacity onPress={() => {}} className="flex-row justify-between items-center p-4">
              <Text className="text-regular-tight text-ink-darkest mr-6">Edit Employment</Text>
              <Feather name="edit" size={24} color={colors.ink.darkest} />
            </TouchableOpacity>
            <Divider />
            <TouchableOpacity onPress={() => {}} className="flex-row justify-between items-center p-4">
              <Text className="text-regular-tight text-ink-darkest mr-6">Remove Employment</Text>
              <Feather name="trash" size={24} color={colors.ink.darkest} />
            </TouchableOpacity>
          </View>
        </Menu> */}
      </View>

      <View className="flex-col mt-5">
        <Text className="text-small-tight font-400 text-ink-darker">Job Title</Text>
        {employment.title && (
          <Text className="text-small-tight font-400 text-ink-darkest mt-1">{employment.title ?? "None"}</Text>
        )}
      </View>

      <View className="flex-col mt-5">
        <Text className="text-small-tight font-400 text-ink-darker">Classification</Text>
        <Text className="text-regular-tight font-400 text-ink-darkest mt-1">{memberClass ?? "None"}</Text>
      </View>

      <View className="flex-col mt-5">
        <Text className="text-small-tight font-400 text-ink-darker">State/Province</Text>
        <Text className="text-regular-tight font-400 text-ink-darkest mt-1">
          {employment.facility.addresses[0]?.state ?? "None"}
        </Text>
      </View>

      <View className="flex-col mt-5">
        <Text className="text-small-tight font-400 text-ink-darker">Section</Text>
        <Text className="text-regular-tight font-400 text-ink-darkest mt-1">{employment.facility.section?.name ?? "None"}</Text>
      </View>
    </View>
  );
};

export default EmploymentSection;
